import React, { useState } from "react";
import "./contact.css";
import { BiX } from "react-icons/bi";

const ContactModal = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    purpose: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit data to Google Sheets or Excel
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/YOUR_GOOGLE_SCRIPT_ID/exec",
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        alert("Data submitted successfully!");
        setFormData({ name: "", number: "", purpose: "" }); // Reset form
        closeModal();
      } else {
        alert("Error submitting data.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modaltitle">
        <h2 className="contcttitle">Contact Us</h2>
        <button className="close-btn" onClick={closeModal}>
          <BiX/>
        </button>
        </div>
        <form onSubmit={handleSubmit} className="contactform">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="number"
            placeholder="Your Phone Number"
            value={formData.number}
            onChange={handleChange}
            required
          />
          <textarea
            name="purpose"
            placeholder="Purpose of Contact"
            value={formData.purpose}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" className="submitbtn">Submit</button>
        </form>
        
      </div>
    </div>
  );
};

export default ContactModal;
